<template>
  <div class="app-container">
    <header class="header">
      <WebNavigation v-if="!isMobile" />
      <MobileNavigation v-else />
    </header>
    <div class="header-placeholder"></div>
    <main class="main-content">
      <router-view></router-view>
    </main>
    <TheFooter />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import WebNavigation from '@/components/WebNavigation.vue';
import MobileNavigation from '@/components/MobileNavigation.vue';
import TheFooter from '@/components/TheFooter.vue';

const router = useRouter()

// 路由变化时滚动到顶部
router.afterEach(() => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
})

// 移动设备检测逻辑
const isMobile = ref(false)

const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768
}

onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})
</script>

<style>
@import '../src/font/font.css';
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  font-family: Arial, Proxima Nova, sans-serif;
}

h1 {
  font-size: 64px;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.app-container {
  max-width: 1200px;
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

.header {
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 0.5px 1px rgba(0, 0, 0, 0.1);
}

.header-placeholder {
  height: 60px;
}

.tab-btn {
  padding: 12px 20px;
  border-radius: 0px;
  background-color: #000;
  color: #fff;
  border: none;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-btn:not(.active) {
  background-color: transparent;
  color: #000;
  /* border: 1px solid #000; */
}
</style>
